export default __webpack_public_path__ + "static/media/zone.21408e80.svg";